import { useTranslation } from 'react-i18next';

import { CustomGeometryClassNames } from '../../../../types/custom';

export const InstanceName = ({
  name,
  geometryClass,
}: {
  name: string | undefined;
  geometryClass: CustomGeometryClassNames;
  className?: string;
}) => {
  const { t } = useTranslation();
  return (
    <>
      {name}
      {!name && (
        <span className="text-muted">
          {t('treeBreadcrumb.unnamed')}{' '}
          {t('geometryClasses.' + geometryClass, {
            count: 1,
          })}
        </span>
      )}
    </>
  );
};
